// extracted by mini-css-extract-plugin
export default {"internalLayout":"create_internalLayout__0u85n","formContainer":"create_formContainer__OXyGY","footerActions":"create_footerActions__v6EO-"};